"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _layout = require("../layout");

var _context = require("../context");

var _utils = require("../utils");

var _helpers = require("../helpers");

var _getUniqueID = require("../utils/getUniqueID");

var _constants = require("./constants");

var _ExpanderContent = _interopRequireDefault(require("./ExpanderContent"));

var _defaultTitleRenderer = require("./defaultTitleRenderer");

var _core = require("@emotion/core");

var ExpanderWithoutDocs = function ExpanderWithoutDocs(_ref) {
  var triggerTextWhenCollapsed = _ref.triggerTextWhenCollapsed,
      triggerTextWhenExpanded = _ref.triggerTextWhenExpanded,
      children = _ref.children,
      titleText = _ref.titleText,
      _ref$renderTitle = _ref.renderTitle,
      renderTitle = _ref$renderTitle === void 0 ? _defaultTitleRenderer.defaultTitleRenderer : _ref$renderTitle,
      isExpandedProp = _ref.isExpanded,
      onToggle = _ref.onToggle,
      _ref$shouldExpandOnMo = _ref.shouldExpandOnMount,
      shouldExpandOnMount = _ref$shouldExpandOnMo === void 0 ? _constants.ExpanderDefaultProps.shouldExpandOnMount : _ref$shouldExpandOnMo,
      _ref$contentSpacing = _ref.contentSpacing,
      contentSpacing = _ref$contentSpacing === void 0 ? _constants.ExpanderDefaultProps.contentSpacing : _ref$contentSpacing,
      _ref$shouldVisuallyHi = _ref.shouldVisuallyHideTriggerText,
      shouldVisuallyHideTriggerText = _ref$shouldVisuallyHi === void 0 ? _constants.ExpanderDefaultProps.shouldVisuallyHideTriggerText : _ref$shouldVisuallyHi,
      dataTestId = _ref.dataTestId;

  var _useState = (0, _react.useState)((0, _getUniqueID.getUniqueID)()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      idNumber = _useState2[0];

  var _useState3 = (0, _react.useState)(shouldExpandOnMount),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isExpandedState = _useState4[0],
      setIsExpandedState = _useState4[1];

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var expanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedState;

  var toggle = function toggle() {
    setIsExpandedState(!expanded);
    !!onToggle && onToggle(!expanded);
  };

  var spacingTop = typeof contentSpacing === 'number' ? contentSpacing : selectors.space(contentSpacing) || 0;
  var triggerText = expanded ? triggerTextWhenExpanded : triggerTextWhenCollapsed;
  var dataTestProps = {
    'data-test-component': 'StencilExpander',
    'data-test-id': dataTestId
  };

  if (!(0, _utils.envIsProduction)()) {
    if (!triggerTextWhenExpanded || !triggerTextWhenCollapsed) {
      console.warn("For accessibility, non-empty strings for \"triggerTextWhenExpanded\" and \"triggerTextWhenCollapsed\" must be passed into Expander. To visually hide the text and use it as alt text instead, use the \"shouldVisuallyHideTriggerText\" prop. Check the Expander with data-test-flagged=\"accessibility-missing-alt-text\".");
      dataTestProps['data-test-flagged'] = 'accessibility-missing-alt-text';
    }
  }

  var id = "StencilExpander-".concat(idNumber);
  return (0, _core.jsx)(_layout.Col, dataTestProps, (0, _core.jsx)(_layout.Row, {
    justifyContent: "space-between",
    alignItems: "center"
  }, (0, _core.jsx)("div", {
    id: id,
    "data-test-component": "StencilExpanderTitle"
  }, renderTitle({
    titleText: titleText,
    toggle: toggle
  })), (0, _core.jsx)(_layout.Spacer, {
    minWidth: _constants.TITLE_HORIZONTAL_SPACING
  }), (0, _core.jsx)(_helpers.TriggerButton, {
    isExpanded: expanded,
    onClick: toggle,
    iconAltText: shouldVisuallyHideTriggerText ? triggerText : undefined,
    "aria-describedby": id
  }, shouldVisuallyHideTriggerText ? undefined : triggerText)), (0, _core.jsx)(_ExpanderContent.default, {
    isExpanded: expanded,
    spacingTop: spacingTop
  }, children));
};

ExpanderWithoutDocs.defaultProps = (0, _objectSpread2.default)({}, _constants.ExpanderDefaultProps);
var Expander = (0, _stencilReactDesc.describe)(ExpanderWithoutDocs).description('Container which shows and hides content, controlled by a trigger button.');
Expander.propTypes = {
  triggerTextWhenCollapsed: _stencilReactDesc.PropTypes.string.isRequired.description("Text displayed in the trigger button when the Expander is collapsed. This will be used as alt text for the chevron icon if 'shouldVisuallyHideTriggerText' is true."),
  triggerTextWhenExpanded: _stencilReactDesc.PropTypes.string.isRequired.description("Text displayed in the trigger button when the Expander is expanded. This will be used as alt text for the chevron icon if 'shouldVisuallyHideTriggerText' is true."),
  children: _stencilReactDesc.PropTypes.node.description('Content to display in the container.'),
  titleText: _stencilReactDesc.PropTypes.string.description('Title to display above the expandable content.'),
  renderTitle: _stencilReactDesc.PropTypes.func.description('Customises how the title is displayed.').format("({\n  titleText: string,\n  toggle: () => void\n}) => ReactNode"),
  isExpanded: _stencilReactDesc.PropTypes.bool.description('Overrides the state of the component to control whether it is expanded or collapsed.'),
  onToggle: _stencilReactDesc.PropTypes.func.description('Callback called when the trigger button is clicked. The argument will be the new state of the component.').format('(isExpanded: boolean) => void'),
  shouldExpandOnMount: _stencilReactDesc.PropTypes.bool.description('Whether the component should expand by default on first render.'),
  contentSpacing: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.number, _stencilReactDesc.PropTypes.string]).description('Spacing between the title and the expandable content.'),
  shouldVisuallyHideTriggerText: _stencilReactDesc.PropTypes.bool.description('Hides the text in the trigger button and uses it as alt text for the chevron icon instead.'),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
};
Expander.displayName = 'Expander';
var _default = Expander;
exports.default = _default;